import { render, staticRenderFns } from "./wapCommonHead.vue?vue&type=template&id=019898c7&scoped=true"
import script from "./wapCommonHead.vue?vue&type=script&lang=js"
export * from "./wapCommonHead.vue?vue&type=script&lang=js"
import style0 from "./wapCommonHead.vue?vue&type=style&index=0&id=019898c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019898c7",
  null
  
)

export default component.exports